var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';
import ImportedCarousel from 'react-multi-carousel';
import useStyles from './Carousel.styles';
import { Box } from '@mui/material';
const Carousel = (_a) => {
    var { ref, carouselContainerClass } = _a, props = __rest(_a, ["ref", "carouselContainerClass"]);
    const { classes } = useStyles();
    const containerRef = useRef(null);
    useEffect(() => {
        if (!props.infinite)
            return;
        const container = containerRef.current;
        if (!container)
            return;
        const demoteClonedHeadings = () => {
            const track = container.querySelector('.react-multi-carousel-track');
            if (!track)
                return;
            const items = Array.from(track.children);
            const totalRendered = items.length;
            const originalCount = React.Children.toArray(props.children).filter(Boolean).length;
            if (totalRendered <= originalCount || originalCount === 0)
                return;
            const clonePrefixCount = Math.floor((totalRendered - originalCount) / 2);
            const originalStart = clonePrefixCount;
            const originalEnd = clonePrefixCount + originalCount;
            for (let i = 0; i < totalRendered; i++) {
                const isClone = i < originalStart || i >= originalEnd;
                if (isClone) {
                    const item = items[i];
                    const headings = item.querySelectorAll('h1, h2, h3, h4, h5, h6');
                    headings.forEach((heading) => {
                        var _a;
                        const div = document.createElement('div');
                        for (const attr of Array.from(heading.attributes)) {
                            div.setAttribute(attr.name, attr.value);
                        }
                        div.dataset.clonedHeading = 'true';
                        div.setAttribute('aria-hidden', 'true');
                        div.innerHTML = heading.innerHTML;
                        (_a = heading.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(div, heading);
                    });
                }
            }
        };
        demoteClonedHeadings();
        const observer = new MutationObserver((mutations) => {
            const hasNewTrackOrHeadings = mutations.some((mutation) => {
                if (mutation.type === 'childList') {
                    return Array.from(mutation.addedNodes).some((node) => {
                        if (node instanceof HTMLElement) {
                            return (node.matches('.react-multi-carousel-track, .react-multi-carousel-item, h1, h2, h3, h4, h5, h6') ||
                                node.querySelector('h1, h2, h3, h4, h5, h6') !== null);
                        }
                        return false;
                    });
                }
                return false;
            });
            if (hasNewTrackOrHeadings) {
                demoteClonedHeadings();
            }
        });
        observer.observe(container, { childList: true, subtree: true });
        return () => {
            observer.disconnect();
        };
    }, [props.infinite, props.children]);
    return (_jsx(Box, { className: clsx(classes.carousel, carouselContainerClass), ref: containerRef, children: _jsx(ImportedCarousel, Object.assign({}, props, { ref: ref })) }));
};
Carousel.displayName = 'Carousel';
export default Carousel;
